// const lockr = require("./lockr");
import lockr from "./lockr.js";
// console.log(lockr)
const excludeKeys = ["copyright_version","openSystemInfo","belongSystem"];
let Lockr = new lockr();
const Storage = class {
  constructor(prefix) {
    Lockr.setPrefix(prefix);
  }

  set(key, value, expireTime = 0) {
    let obj = { value, timestamp: 0 };
    if (expireTime && expireTime > 0) {
      let timestamp = parseInt(new Date().getTime() / 1000 + "") + expireTime;
      obj.timestamp = timestamp;
    }
    Lockr.set(`${key}`, obj);
  }

  setValue(key, value, localKey) {
    let info = this.get(localKey) || {};
    info[key] = value;
    this.set(localKey, info);
  }

  get(key) {
    let data = Lockr.get(`${key}`) || {};
    if (data.timestamp) {
      let nowTime = parseInt(new Date().getTime() / 1000 + "");
      if (nowTime < data.timestamp) {
        return data.value;
      }
      return null;
    }
    return data.value;
  }
  removeBatch(prefix) {
    let keys = Lockr.keys();
    keys?.forEach((o) => {
      if (o.indexOf(prefix) == 0) {
        this.remove(o);
      }
    });
  }
  removeBatchExclude(prefix, key) {
    let keys = Lockr.keys();
    keys?.forEach((o) => {
      if (o.indexOf(prefix) == 0) {
        if (o != key) {
          this.remove(o);
        }
      }
    });
  }
  remove(key) {
    Lockr.rm(key);
  }

  flush() {
    Lockr.flush(excludeKeys);
  }
  size() {
    var size = 0;
    let obj = window.localStorage;
    if (obj) {
      for (let item in window.localStorage) {
        if (obj.hasOwnProperty(item)) {
          size += obj.getItem(item)?.length || 0;
        }
      }
      // console.log("localstorage当前已用存储：" + (size / 1024 / 1024).toFixed(4) + "MB");
    }
  }
};
// module.exports = Storage;
export default Storage;
